module.exports = __webpack_public_path__ + "img/close.b276af38.svg";